import { Box, Group, Text, useMantineTheme } from "@mantine/core";

interface QuestionContextProps {
  label: string;
  number: number;
  inverted?: boolean;
}

export function QuestionContext({ label, number, inverted = false }: QuestionContextProps) {
  const { semanticColors } = useMantineTheme().other;
  const color = inverted ? semanticColors.fgOnDarkDim : semanticColors.textSecondary;
  const badgeSize = inverted ? 24 : 28;

  return (
    <Group gap={inverted ? "xs" : "sm"} align="flex-start" wrap="nowrap">
      <Box
        component="span"
        mt={2}
        w={badgeSize}
        h={badgeSize}
        bdrs="xl"
        c={color}
        bg={inverted ? "rgba(0, 0, 0, 0.24)" : "var(--mantine-color-gray-1)"}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          border: inverted ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid var(--mantine-color-gray-3)",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        <Text component="span" fz={inverted ? "xs" : "sm"} fw={600} lh={1}>
          {number}
        </Text>
      </Box>
      <Text
        c={color}
        fz={inverted ? "sm" : "lg"}
        fw={600}
        lh={1.4}
        maw={inverted ? "46rem" : "56rem"}
        lineClamp={inverted ? 2 : undefined}
        style={{ textWrap: "pretty" }}
      >
        {label}
      </Text>
    </Group>
  );
}
